export default "__VITE_ASSET__0bef71af__"